export default __webpack_public_path__ + "static/media/square.892da48a.svg";